import { render, staticRenderFns } from "./BrazePrompt.vue?vue&type=template&id=24a5846f&"
import script from "./BrazePrompt.vue?vue&type=script&lang=js&"
export * from "./BrazePrompt.vue?vue&type=script&lang=js&"
import style0 from "./BrazePrompt.vue?vue&type=style&index=0&id=24a5846f&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports